import React, { useRef } from 'react';

import { useTranslations } from 'next-intl';

import { ButtonExperiment } from '@/components/ButtonExperiment';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

type Props = {
  isFollowing?: boolean;
  onButtonClick: () => void;
  isUpdatingFollowCount: boolean;
  className?: string;
};

export function FollowsButton({
  isFollowing = false,
  onButtonClick,
  isUpdatingFollowCount,
  className,
}: Props) {
  const [isAuthenticated] = useCurrentUser();
  const tShop = useTranslations('shop');
  const modalTrigger = useRef<HTMLButtonElement>(null);

  return (
    <ButtonExperiment
      variant="primary"
      size="small"
      legacyColor={isFollowing ? 'green' : 'blue'}
      legacyClassName={className}
      ref={modalTrigger}
      onClick={onButtonClick}
      disabled={isUpdatingFollowCount}
    >
      {isFollowing && isAuthenticated
        ? tShop('Button.Following')
        : tShop('Button.Follow')}
    </ButtonExperiment>
  );
}
